'use client';

var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;
var VNW_TRACKING_GA = 'VNW_TRACKING_GA';
var VNW_TRACKING_GA_FIRST = 'VNW_TRACKING_GA_FIRST';
// Additional height for privacy policy of Popup footer in responsive
var ADDITIONAL_HEIGHT_PRIVACY_POLICY = 72;
// Additional height for footer when privacy have error
var POLICY_ERROR = 50;
var UNDEFINED_VALUE = 'undefined';
var SCREEN_WIDTH_MOBILE = 768;

export { ADDITIONAL_HEIGHT_PRIVACY_POLICY, DIRECTOR_LEVEL, FRESHER_LEVEL, INTERN_LEVEL, MANAGER_LEVEL, POLICY_ERROR, SCREEN_WIDTH_MOBILE, UNDEFINED_VALUE, VNW_TRACKING_GA, VNW_TRACKING_GA_FIRST };
//# sourceMappingURL=const.js.map
